import React from 'react';
import classNames from 'classnames/bind';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { useSwiperSlide } from 'swiper/react';
import { enhancedConnect } from "../../../../utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _StepsCustomizableSlide = function _StepsCustomizableSlide(_ref) {
  var children = _ref.children,
    _ref$innerSize = _ref.innerSize,
    innerSize = _ref$innerSize === void 0 ? 'default' : _ref$innerSize;
  var swiperSlide = useSwiperSlide();
  var isActive = swiperSlide.isActive;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('slide', {
      'slide-active': isActive
    }),
    "data-t-id": "slides-StepsCustomizableSlide"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('card', "innerSize--".concat(innerSize))
  }, children));
};
export var StepsCustomizableSlide = compose(enhancedConnect(), withAutoMetric.Item(function () {
  return {
    name: 'ThirdSlide'
  };
}))(_StepsCustomizableSlide);